// Container imports
const {
  INTEREST_FOLLOWING_CHANGE_PENDING,
  INTEREST_FOLLOWING_CHANGE
} = require('./actions')
const InterestModelRecord = require('./record')

// eslint-disable-next-line complexity
function interestReducer(state, { type, payload }) {
  // Sanity check
  if (!payload || !(state instanceof InterestModelRecord)) {
    return state
  }
  // Ignore actions that don't refer to this interest
  if (state.key !== payload.interestKey) {
    return state
  }
  switch (type) {
    case INTEREST_FOLLOWING_CHANGE: {
      const countDiff = followersCountDiff(payload)
      return state.merge({
        followersCount: state.followersCount + countDiff,
        isFollowing: payload.isFollowing
      })
    }
    default:
      return state
  }
}

module.exports = interestReducer

function followersCountDiff({ isFollowing }) {
  if (isFollowing === INTEREST_FOLLOWING_CHANGE_PENDING) {
    return 0
  }
  return isFollowing ? +1 : -1
}
